import { render, staticRenderFns } from "./ReferenceTab.vue?vue&type=template&id=dbf1c976"
import script from "./ReferenceTab.vue?vue&type=script&lang=js"
export * from "./ReferenceTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports